<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="ibox form">
                <div class="ibox-title ibox-grey">
                    <h4>{{ __('sell_analyze_from_24_months') }}</h4>
                    <div class="ibox-tools">
                        <button-open-help-modal :in-extra-div="false" :helpName="'ASC-002'"/>
                    </div>
                </div>
                <div class="ibox-content">
                    <p class="text-right"><em>{{__('all_values_in_base_currency')}}</em></p>
                    <table class="table table-striped table-fixed" id="main-table">
                        <thead>
                        <tr>
                            <th class="text-center text-truncate text-wrap th-first">
                                {{ __('month') }}
                            </th>
                            <th class="text-center text-truncate text-wrap">
                                {{ __('document_count') }}
                            </th>
                            <th class="text-center text-truncate text-wrap">
                                {{ __("net_value_without_correction") }}
                            </th>
                            <th class="text-center text-truncate text-wrap">
                                {{ __("gross_value_without_correction") }}
                            </th>
                            <th class="text-center text-truncate text-wrap">
                                {{ __("net_value_after_correction") }}
                            </th>
                            <th class="text-center text-truncate text-wrap th-last">
                                {{ __("gross_value_after_correction") }}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="key in Object.keys(sellSummary)" :key="key" v-if="shouldShowRow(key)">
                            <td>{{key}}</td>
                            <td class="text-right">{{sellSummary[key]['document_sum']}}</td>
                            <td class="text-right">{{money.localize(sellSummary[key]['net_amount_sum'])}}</td>
                            <td class="text-right">{{money.localize(sellSummary[key]['gross_amount_sum'])}}</td>
                            <td class="text-right">{{money.localize(sellSummary[key]['net_amount_corrected_sum'])}}</td>
                            <td class="text-right">{{money.localize(sellSummary[key]['gross_amount_corrected_sum'])}}</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import {Money} from './../../../services/Money.js';
export default {
    name: "SellTable",
    props: {
        sellSummary: {
            type: Object
        }
    },
    data: function () {
        return {
            money: new Money()
        }
    },
    methods:{
        shouldShowRow(key) {
            // Sprawdź, czy this.sellSummary istnieje i czy this.sellSummary[key] jest zdefiniowane


            // Sprawdź, czy dla danego klucza wszystkie wartości są równe 0
            const areAllValuesZero = Object.values(this.sellSummary[key]).every(value => value === 0);

            // Jeśli wszystkie wartości dla danego klucza są równe 0, sprawdź dla każdego kolejnego klucza
            if (areAllValuesZero) {
                const nextKeys = Object.keys(this.sellSummary).slice(Object.keys(this.sellSummary).indexOf(key) + 1);

                for (const nextKey of nextKeys) {
                    // Sprawdź, czy dla każdego kolejnego klucza wszystkie wartości są równe 0
                    if (!this.sellSummary[nextKey] || Object.values(this.sellSummary[nextKey]).some(value => value !== 0)) {
                        return true; // Jeśli wartości dla któregokolwiek z kolejnych kluczy nie są równe 0, zwróć true
                    }
                }
            }

            return !areAllValuesZero; // Zwróć true, jeśli wartości dla danego klucza nie są wszystkie równe 0
        },
    }
}
</script>

<style scoped>

</style>
